import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Departamento, Empregador, Funcionario, JornadaPonto } from '../../api.service';
import { ModoCameraFacial } from '../../shared/camera-facial.component';
import { RodapeCrudComponent } from '../../shared/rodape-crud.component';
import { ServicoBuscaCadastro } from '../../shared/servico-busca-cadastro';
import { ServicoCameraFacial } from '../../shared/servico-camera-facial';
import { ServicoFluxoFacial } from '../../shared/servico-fluxo-facial';
import { ServicoMensagemAplicacao } from '../../shared/servico-mensagem-aplicacao';
import { CaixaFaceDetectada, ServicoReconhecimentoFacial } from '../../shared/servico-reconhecimento-facial';
import { ServicoVozRegistro } from '../registrador/servico-voz-registro';
import { ModalPesquisaFuncionarioComponent } from './modal-pesquisa-funcionario.component';
import { PainelDadosFuncionarioComponent } from './painel-dados-funcionario.component';
import { PainelFaceFuncionarioComponent } from './painel-face-funcionario.component';
import { SeletorFuncionarioExistenteComponent } from './seletor-funcionario-existente.component';
import { EstadoFaceFuncionario, ServicoFaceFuncionario } from './servico-face-funcionario';
import { ServicoFuncionarioAdministrativo } from './servico-funcionario-administrativo';
import { ServicoFiltroDepartamento } from '../../shared/servico-filtro-departamento';
import { SeletorMultiploDepartamentosComponent } from '../../shared/seletor-multiplo-departamentos.component';

@Component({
  selector: 'app-tela-funcionario',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ModalPesquisaFuncionarioComponent,
    PainelDadosFuncionarioComponent,
    PainelFaceFuncionarioComponent,
    RodapeCrudComponent,
    SeletorFuncionarioExistenteComponent,
    SeletorMultiploDepartamentosComponent
  ],
  templateUrl: './tela-funcionario.component.html'
})
export class TelaFuncionarioComponent implements OnChanges, OnDestroy {
  @Input({ required: true }) funcionario!: Funcionario;
  @Input() empregadores: Empregador[] = [];
  @Input() funcionarios: Funcionario[] = [];
  @Input() departamentos: Departamento[] = [];
  @Input() jornadas: JornadaPonto[] = [];
  @Input() empregadorSelecionado = '';
  @Input() buscaPersistida = '';

  @Output() empregadorSelecionadoChange = new EventEmitter<string>();
  @Output() funcionarioChange = new EventEmitter<Funcionario>();
  @Output() alterarEmpregador = new EventEmitter<void>();
  @Output() mensagem = new EventEmitter<string>();
  @Output() limpar = new EventEmitter<Funcionario>();
  @Output() salvar = new EventEmitter<Funcionario>();
  @Output() excluir = new EventEmitter<void>();
  @Output() selecionar = new EventEmitter<Funcionario>();
  @Output() digitouCpf = new EventEmitter<void>();
  @Output() buscaPersistidaChange = new EventEmitter<string>();

  buscaFuncionario = '';
  buscaFuncionarioModal = '';
  departamentoFiltro: string[] = [];
  modalFuncionariosAberta = false;
  cameraAtiva = false;
  cameraModo: ModoCameraFacial = 'cadastro';
  rostoDetectado = false;
  provaVidaOk = false;
  capturando = false;
  mensagemCamera = '';
  caixaFace?: CaixaFaceDetectada;
  detectorDisponivel = false;
  private descritorFacialAtual: number[] = [];
  private monitoramentoFacial?: number;
  private monitoramentoOcupado = false;
  private registroAutomaticoDisparado = false;
  private leiturasFaceValidacao = 0;
  private validacaoCooldownAte = 0;

  get limiteFacesReferencia() {
    return this.servicoFaceFuncionario.limiteFacesReferencia;
  }

  constructor(
    private readonly servicoBuscaCadastro: ServicoBuscaCadastro,
    private readonly servicoCameraFacial: ServicoCameraFacial,
    private readonly servicoFaceFuncionario: ServicoFaceFuncionario,
    private readonly servicoFluxoFacial: ServicoFluxoFacial,
    private readonly servicoFuncionarioAdministrativo: ServicoFuncionarioAdministrativo,
    private readonly servicoFiltroDepartamento: ServicoFiltroDepartamento,
    private readonly servicoMensagemAplicacao: ServicoMensagemAplicacao,
    private readonly servicoReconhecimentoFacial: ServicoReconhecimentoFacial,
    private readonly servicoVozRegistro: ServicoVozRegistro
  ) {
    this.servicoVozRegistro.iniciar();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['funcionario'] && this.funcionario?.id) {
      this.buscaFuncionario = this.rotuloFuncionario(this.funcionario);
    }
    if (changes['funcionario'] && !this.funcionario?.id) {
      this.buscaFuncionario = this.buscaPersistida;
    }
    if (changes['buscaPersistida'] && !this.funcionario?.id) {
      this.buscaFuncionario = this.buscaPersistida;
    }
  }

  ngOnDestroy() {
    this.fecharCamera();
  }

  get funcionariosFiltrados() {
    return this.servicoBuscaCadastro.filtrarFuncionarios(
      this.funcionariosPorDepartamento,
      this.buscaFuncionario,
      this.funcionario.id || ''
    );
  }

  get funcionariosModal() {
    return this.servicoBuscaCadastro.listarFuncionariosModal(this.funcionariosPorDepartamento, this.buscaFuncionarioModal);
  }

  get funcionariosPorDepartamento() {
    return this.servicoFiltroDepartamento.funcionariosNoRecorte(
      this.funcionarios,
      this.departamentoFiltro,
      this.departamentos
    );
  }

  alterarDepartamentoFiltro(departamentoIds: string[]) {
    this.departamentoFiltro = departamentoIds;
    this.buscaFuncionario = '';
    this.buscaPersistidaChange.emit('');
  }

  rotuloFuncionario = (item: unknown) => this.servicoBuscaCadastro.rotuloFuncionario(item);

  detalheFuncionario = (item: unknown) => this.servicoBuscaCadastro.detalheFuncionario(item);

  alterarBusca(valor: string) {
    this.buscaFuncionario = valor;
    this.buscaPersistidaChange.emit(valor);
    if (!valor.trim()) {
      this.limparFuncionario();
      return;
    }
    if (valor.trim().length < 3) {
      return;
    }

    if (this.funcionariosFiltrados.length === 1) {
      this.selecionarFuncionario(this.funcionariosFiltrados[0], false);
    }
  }

  abrirModalFuncionarios() {
    this.buscaFuncionarioModal = '';
    this.modalFuncionariosAberta = true;
  }

  fecharModalFuncionarios() {
    this.buscaFuncionarioModal = '';
    this.modalFuncionariosAberta = false;
  }

  limparBuscaFuncionarioModal() {
    this.buscaFuncionarioModal = '';
  }

  selecionarFuncionario(item: unknown, fecharModal = true) {
    const funcionario = item as Funcionario;
    if (!funcionario.id) {
      return;
    }

    this.servicoFuncionarioAdministrativo.buscar(funcionario.id).subscribe({
      next: detalhe => {
        this.funcionario = this.servicoFuncionarioAdministrativo.prepararEdicao(detalhe, this.empregadorSelecionado);
        this.buscaFuncionario = this.rotuloFuncionario(this.funcionario);
        this.buscaPersistidaChange.emit(this.buscaFuncionario);
        this.fecharCamera();
        this.mensagem.emit(this.servicoFuncionarioAdministrativo.mensagemFuncionarioCarregado(detalhe));
        this.selecionar.emit(this.funcionario);
      },
      error: () => this.mensagem.emit(this.servicoFuncionarioAdministrativo.mensagemErroCarregar())
    });
    if (fecharModal) {
      this.fecharModalFuncionarios();
    }
  }

  limparFuncionario() {
    this.buscaFuncionario = '';
    this.buscaPersistidaChange.emit('');
    this.funcionario = this.servicoFuncionarioAdministrativo.novoFuncionario(this.empregadorSelecionado);
    this.fecharCamera();
    this.funcionarioChange.emit(this.funcionario);
    this.limpar.emit(this.funcionario);
  }

  salvarFuncionario() {
    if (!this.servicoFuncionarioAdministrativo.cpfValido(this.funcionario)) {
      this.mensagem.emit(this.servicoFuncionarioAdministrativo.mensagemCpfInvalido());
      return;
    }
    if (this.funcionario.senhaPortal && this.funcionario.senhaPortal.trim().length < 6) {
      this.mensagem.emit('Senha do portal deve ter pelo menos 6 caracteres.');
      return;
    }

    const editando = !!this.funcionario.id;
    const funcionarioPayload = this.servicoFuncionarioAdministrativo.prepararSalvar(this.funcionario, this.empregadorSelecionado);
    this.servicoFuncionarioAdministrativo.salvar(funcionarioPayload).subscribe({
      next: salvo => {
        this.mensagem.emit(this.servicoMensagemAplicacao.registroSalvo(editando));
        this.funcionario = this.servicoFuncionarioAdministrativo.prepararEdicao(salvo, this.empregadorSelecionado);
        this.buscaFuncionario = this.rotuloFuncionario(this.funcionario);
        this.buscaPersistidaChange.emit(this.buscaFuncionario);
        this.fecharCamera();
        this.funcionarioChange.emit(this.funcionario);
        this.salvar.emit(this.funcionario);
      },
      error: erro => this.mensagem.emit(this.servicoMensagemAplicacao.erroApi(erro, this.servicoFuncionarioAdministrativo.mensagemErroSalvar()))
    });
  }

  excluirFuncionario() {
    if (!this.funcionario.id || !window.confirm('Confirma excluir este funcionario?')) {
      return;
    }

    this.servicoFuncionarioAdministrativo.excluir(this.funcionario.id).subscribe({
      next: () => {
        this.mensagem.emit(this.servicoMensagemAplicacao.registroExcluido());
        this.limparFuncionario();
        this.excluir.emit();
      },
      error: () => this.mensagem.emit(this.servicoFuncionarioAdministrativo.mensagemErroExcluir())
    });
  }

  get statusFaceReferencia() {
    return this.servicoFaceFuncionario.statusFaceReferencia(this.funcionario);
  }

  async abrirCameraCadastro() {
    await this.abrirCamera('cadastro');
  }

  async abrirCameraValidacaoFuncionario() {
    if (!this.funcionario.id) {
      this.mensagem.emit('Selecione e salve um funcionario antes de validar a face.');
      return;
    }
    if (this.statusFaceReferencia !== 'capturada') {
      this.mensagem.emit('Funcionario sem face de referencia cadastrada.');
      return;
    }
    await this.abrirCamera('validacao');
  }

  private async abrirCamera(modo: ModoCameraFacial) {
    try {
      this.servicoVozRegistro.prepararAudio();
      this.fecharCamera();
      this.servicoCameraFacial.configurar({
        zoomCamera: 1,
        areaLeituraCameraPercentual: 100
      });
      await this.servicoCameraFacial.abrir();
      this.aplicarEstadoFaceFuncionario(this.servicoFaceFuncionario.estadoAbertura(modo));
      this.servicoReconhecimentoFacial.resetarProvaVida();
      this.mensagem.emit(this.servicoFluxoFacial.mensagemAberturaCamera(modo));
      window.setTimeout(async () => {
        this.servicoCameraFacial.conectarVideo();
        this.detectorDisponivel = await this.servicoReconhecimentoFacial.carregarDetector();
        this.mensagemCamera = this.mensagemInicialCamera(modo);
        this.iniciarMonitoramentoFacial();
      }, 0);
    } catch {
      this.mensagem.emit('Nao foi possivel acessar a camera. Verifique permissao do navegador e webcam.');
    }
  }

  capturarERegistrar() {
    const fotoCapturada = this.servicoCameraFacial.capturarImagemBase64();
    if (!fotoCapturada) {
      this.mensagem.emit('Camera ainda nao esta pronta.');
      return;
    }

    if (!this.servicoFaceFuncionario.capturaValida(
      this.cameraModo,
      this.rostoDetectado,
      this.provaVidaOk,
      this.descritorFacialAtual
    )) {
      this.mensagem.emit(this.servicoFluxoFacial.mensagemCapturaInvalida(this.detectorDisponivel));
      return;
    }

    if (this.cameraModo === 'cadastro') {
      if (this.funcionario.id) {
        if (this.quantidadeFacesAtivas() >= this.limiteFacesReferencia) {
          this.mensagem.emit(`Limite de ${this.limiteFacesReferencia} faces de referencia atingido para este funcionario.`);
          this.fecharCamera();
          return;
        }
        this.capturando = true;
        this.servicoFuncionarioAdministrativo.cadastrarFace(this.funcionario.id, fotoCapturada, this.descritorFacialAtual).subscribe({
          next: funcionarioAtualizado => {
            this.funcionario = this.servicoFuncionarioAdministrativo.prepararEdicao(funcionarioAtualizado, this.empregadorSelecionado);
            this.funcionarioChange.emit(this.funcionario);
            this.fecharCamera();
            this.mensagem.emit(`Face cadastrada para ${this.funcionario.nome}.`);
            this.salvar.emit(this.funcionario);
          },
          error: erro => {
            this.capturando = false;
            this.mensagem.emit(this.servicoMensagemAplicacao.erroApi(erro, 'Erro ao cadastrar face do funcionario.'));
          }
        });
        return;
      }

      this.funcionario = this.servicoFluxoFacial.aplicarFaceCadastro(this.funcionario, fotoCapturada, this.descritorFacialAtual);
      this.funcionarioChange.emit(this.funcionario);
      this.fecharCamera();
      this.mensagem.emit('Face capturada para o cadastro. Salve o funcionario para gravar.');
      return;
    }

    if (!this.funcionario.id) {
      this.mensagem.emit('Selecione um funcionario para validar a face.');
      return;
    }

    this.capturando = true;
    this.mensagemCamera = this.servicoFaceFuncionario.mensagemValidando(this.funcionario.nome);
    this.mensagem.emit(this.mensagemCamera);
    this.servicoFuncionarioAdministrativo.validarFace(this.funcionario.id, this.descritorFacialAtual).subscribe({
      next: () => {
        const usarAtrasoMobile = this.servicoCameraFacial.ehCameraMobile();
        const mensagemSucesso = this.servicoFaceFuncionario.mensagemFuncionarioEncontrado(this.funcionario.nome);
        this.mensagemCamera = mensagemSucesso;
        this.mensagem.emit(mensagemSucesso);
        this.servicoVozRegistro.falar(`Funcionario encontrado. ${this.funcionario.nome}`, usarAtrasoMobile);
        window.setTimeout(() => this.fecharCamera(), 1800);
      },
      error: erro => {
        const mensagemErro = this.servicoMensagemAplicacao.erroApi(erro, 'Face nao confere com o funcionario selecionado.');
        this.aplicarEstadoFaceFuncionario(this.servicoFaceFuncionario.aplicarFalhaValidacao(this.estadoFaceAtual(), mensagemErro));
        this.mensagem.emit(mensagemErro);
        this.servicoVozRegistro.falar(mensagemErro, this.servicoCameraFacial.ehCameraMobile());
      }
    });
  }

  removerFaceFuncionario(faceId: string) {
    if (!this.funcionario.id || !faceId) {
      return;
    }

    this.servicoFuncionarioAdministrativo.removerFace(this.funcionario.id, faceId).subscribe({
      next: funcionarioAtualizado => {
        this.funcionario = this.servicoFuncionarioAdministrativo.prepararEdicao(funcionarioAtualizado, this.empregadorSelecionado);
        this.funcionarioChange.emit(this.funcionario);
        this.mensagem.emit('Face de referencia removida.');
        this.salvar.emit(this.funcionario);
      },
      error: erro => this.mensagem.emit(this.servicoMensagemAplicacao.erroApi(erro, 'Erro ao remover face de referencia.'))
    });
  }

  fecharCamera() {
    this.pararMonitoramentoFacial();
    this.servicoCameraFacial.fechar();
    this.aplicarEstadoFaceFuncionario(this.servicoFaceFuncionario.estadoFechado(this.cameraModo));
    this.servicoReconhecimentoFacial.resetarProvaVida();
  }

  private aplicarEstadoFaceFuncionario(estado: EstadoFaceFuncionario) {
    this.cameraAtiva = estado.cameraAtiva;
    this.cameraModo = estado.cameraModo;
    this.rostoDetectado = estado.rostoDetectado;
    this.provaVidaOk = estado.provaVidaOk;
    this.capturando = estado.capturando;
    this.mensagemCamera = estado.mensagemCamera;
    this.caixaFace = estado.caixaFace;
    this.detectorDisponivel = estado.detectorDisponivel;
    this.descritorFacialAtual = estado.descritorFacialAtual;
    this.registroAutomaticoDisparado = estado.registroAutomaticoDisparado;
    this.leiturasFaceValidacao = estado.leiturasFaceValidacao;
    this.validacaoCooldownAte = estado.validacaoCooldownAte;
  }

  private estadoFaceAtual(): EstadoFaceFuncionario {
    return {
      cameraAtiva: this.cameraAtiva,
      cameraModo: this.cameraModo,
      rostoDetectado: this.rostoDetectado,
      provaVidaOk: this.provaVidaOk,
      capturando: this.capturando,
      mensagemCamera: this.mensagemCamera,
      caixaFace: this.caixaFace,
      detectorDisponivel: this.detectorDisponivel,
      descritorFacialAtual: this.descritorFacialAtual,
      registroAutomaticoDisparado: this.registroAutomaticoDisparado,
      leiturasFaceValidacao: this.leiturasFaceValidacao,
      validacaoCooldownAte: this.validacaoCooldownAte
    };
  }

  private iniciarMonitoramentoFacial() {
    this.pararMonitoramentoFacial();
    if (!this.detectorDisponivel) {
      return;
    }

    this.monitoramentoFacial = window.setInterval(() => this.detectarRosto(), 220);
    this.detectarRosto();
  }

  private pararMonitoramentoFacial() {
    if (this.monitoramentoFacial) {
      window.clearInterval(this.monitoramentoFacial);
      this.monitoramentoFacial = undefined;
    }
  }

  private async detectarRosto() {
    const video = this.servicoCameraFacial.videoAtual();
    if (!video || !this.detectorDisponivel || this.monitoramentoOcupado || this.capturando || video.readyState < HTMLMediaElement.HAVE_CURRENT_DATA) {
      return;
    }

    if (Date.now() < this.validacaoCooldownAte) {
      return;
    }

    this.monitoramentoOcupado = true;
    try {
      const cameraMobile = this.servicoCameraFacial.ehCameraMobile(video);
      const analise = await this.servicoReconhecimentoFacial.analisar(video, cameraMobile);
      this.rostoDetectado = analise.rostoDetectado;
      this.provaVidaOk = analise.provaVidaOk;
      this.descritorFacialAtual = analise.descritorFacial;
      this.caixaFace = analise.caixaFace;
      this.mensagemCamera = this.cameraModo === 'cadastro'
        ? this.servicoFaceFuncionario.mensagemCadastroCamera(this.quantidadeFacesAtivas(), analise.mensagem)
        : analise.mensagem;

      this.leiturasFaceValidacao = this.servicoFaceFuncionario.atualizarLeiturasValidacao(
        this.cameraModo,
        this.rostoDetectado,
        this.descritorFacialAtual,
        this.leiturasFaceValidacao
      );

      if (this.servicoFaceFuncionario.deveDispararValidacaoAutomatica(this.cameraModo, this.leiturasFaceValidacao, this.registroAutomaticoDisparado)) {
        this.registroAutomaticoDisparado = true;
        this.mensagemCamera = this.servicoFaceFuncionario.mensagemValidando(this.funcionario.nome);
        window.setTimeout(() => this.capturarERegistrar(), 100);
      }
    } catch {
      this.aplicarEstadoFaceFuncionario(this.servicoFaceFuncionario.aplicarErroAnalise(this.estadoFaceAtual()));
    } finally {
      this.monitoramentoOcupado = false;
    }
  }

  private quantidadeFacesAtivas() {
    return (this.funcionario.faces || []).filter(face => face.ativo).length;
  }

  private mensagemInicialCamera(modo: ModoCameraFacial) {
    if (!this.detectorDisponivel) {
      return 'Nao foi possivel carregar o detector facial.';
    }

    if (modo === 'cadastro') {
      return `${this.servicoFaceFuncionario.orientacaoCadastro(this.quantidadeFacesAtivas())} Procurando rosto na camera.`;
    }

    return 'Procurando rosto na camera.';
  }

}
